export default __webpack_public_path__ + "static/media/no-course_found.fde09d0e.png";